import { render, staticRenderFns } from "./PersonRegister.vue?vue&type=template&id=9b258f24"
import script from "./PersonRegister.vue?vue&type=script&lang=js"
export * from "./PersonRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports